
export const environment = {
  production: true,
  apiUrl: "https://" + document.location.hostname + "/api"
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts